import { useAppDispatch, useAppSelector } from './reduxHooks'
import {
  fetchFunctionalUnits,
  fetchFunctionalUnit,
  createFunctionalUnit,
  updateFunctionalUnit,
  deleteFunctionalUnit,
  setFilters,
  clearError,
} from '../state/reducers/functionalUnitReducer'
import {
  FunctionalUnitFilters,
  CreateFunctionalUnitDTO,
  UpdateFunctionalUnitDTO,
} from '../services/functionalUnitService'
import { useCallback } from 'react'

export const useFunctionalUnit = () => {
  const dispatch = useAppDispatch()
  const { list, filters, loading, error } = useAppSelector(
    (state) => state.functionalUnits,
  )

  const fetchAll = useCallback(
    (filters?: FunctionalUnitFilters) => {
      return dispatch(fetchFunctionalUnits(filters || {}))
    },
    [dispatch],
  )

  const fetchById = useCallback(
    (id: number) => {
      return dispatch(fetchFunctionalUnit(id))
    },
    [dispatch],
  )

  const create = useCallback(
    (data: CreateFunctionalUnitDTO) => {
      return dispatch(createFunctionalUnit(data))
    },
    [dispatch],
  )

  const update = useCallback(
    (id: number, data: UpdateFunctionalUnitDTO) => {
      return dispatch(updateFunctionalUnit({ id, data }))
    },
    [dispatch],
  )

  const remove = useCallback(
    (id: number) => {
      return dispatch(deleteFunctionalUnit(id))
    },
    [dispatch],
  )

  const updateFilters = useCallback(
    (newFilters: Partial<FunctionalUnitFilters>) => {
      dispatch(setFilters(newFilters))
    },
    [dispatch],
  )

  const clearErrorState = useCallback(() => {
    dispatch(clearError())
  }, [dispatch])

  return {
    functionalUnits: list,
    filters,
    loading,
    error,
    fetchAll,
    fetchById,
    create,
    update,
    remove,
    updateFilters,
    clearError: clearErrorState,
  }
}
